import React, { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './HomePage.css';

import learnIcon from '../assets/learn.png';
import toolsIcon from '../assets/tools.png';
import gamesIcon from '../assets/games.png';
import knowIcon from '../assets/know.png';
import practiceIcon from '../assets/camera.png';
import simulatorIcon from '../assets/simulation.png';

import signmatesLogo from '../assets/signmates_logo_home.svg';
import pokoBall from '../assets/poko_ball.png';
import pokoJump from '../assets/poko_jump.png';
import pokoStand from '../assets/poko_handsInWaist.png';
import pokoButton from '../assets/poko_button.png';

const signpostData = [
  { path: '/info', icon: knowIcon, alt: 'Know More', label: 'Sign & Deaf Info', className: 'know' },
  { path: '/learn', icon: learnIcon, alt: 'Learn signs', label: 'Learn signs', className: 'learn' },
  { path: '/practice', icon: practiceIcon, alt: 'Practice signs', label: 'Practice', className: 'practice' },
  { path: '/tools', icon: toolsIcon, alt: 'Learning Tools', label: 'Learning Tools', className: 'tool' },
  { path: '/games', icon: gamesIcon, alt: 'Fun Games', label: 'Fun Games', className: 'game' },
  { path: '/simulator', icon: simulatorIcon, alt: 'Simulator', label: 'Deaf Simulator', className: 'simulator' }
];

function HomePage() {
  const navigate = useNavigate();
  const pokoRef = useRef();
  const containerRef = useRef();
  const nextPathRef = useRef('');
  const [showInstructions, setShowInstructions] = useState(false);
  const [pokoImg, setPokoImg] = useState(pokoStand);
  const [pokoStyle, setPokoStyle] = useState({});
  const preloadImages = (imageSources) => {
    imageSources.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  };
  const [animationStage, setAnimationStage] = useState(null);
  const [showIntroBubble, setShowIntroBubble] = useState(true);

  useEffect(() => {
    preloadImages([pokoBall, pokoJump, pokoStand]);
  }, []);

  const handleNavigatePath = (path, event) => {
    setShowIntroBubble(false);

    if (window.innerWidth < 768) {
      navigate(path);
      return;
    }

    // Reliable scroll to bottom
    setTimeout(() => {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth',
      });
    }, 50);

    const pokoBox = pokoRef.current.getBoundingClientRect();
    const targetBox = event.currentTarget.getBoundingClientRect();

    const pokoCenterX = pokoBox.left + pokoBox.width / 2;
    const targetCenterX = targetBox.left + targetBox.width / 2;
    const deltaX = targetCenterX - pokoCenterX;

    const distance = Math.abs(deltaX);
    const minDuration = 0.4;
    const maxDuration = 1.2;
    const pixelsPerSecond = 600;
    const duration = Math.min(Math.max(distance / pixelsPerSecond, minDuration), maxDuration);

    nextPathRef.current = path;

    setPokoImg(pokoBall);
    setPokoStyle({
      '--distance': `${deltaX}px`,
      animation: `rollArc ${duration}s ease-in-out forwards`,
    });

    setAnimationStage('ball');
  };


  const handleAnimationEnd = () => {
    if (animationStage === 'ball') {
      // Change to jump pose and jump
      setPokoImg(pokoJump);
      setPokoStyle({
        '--distance': pokoStyle['--distance'],
        animation: 'jumpAtTarget 0.5s ease forwards',
      });

      setAnimationStage('jump');
    } else if (animationStage === 'jump') {
      navigate(nextPathRef.current);
    }
  };

  return (
    <div className="home-page">
      {showInstructions && (
        <div className="instructions-modal-overlay">
          <div className="instructions-modal">
            <button className="close-button" onClick={() => setShowInstructions(false)}>×</button>
            <h2>Welcome to SignMates!</h2>
            
            <div className="video-container">
              <video controls>
                <source src="/video/intro.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      )}

      <div className="hero-wrapper">
        <div className="hero container">
          <img src={signmatesLogo} alt="SignMates Logo" className="logo" />
          <h1>Learn Auslan Sign – Together!</h1>
          <h4>A fun place to learn sign language & understand Deaf friends!</h4>
          <button className="start-button" onClick={() => navigate('/info')}>
            <img src={pokoButton} alt="poko" />
            Let’s Learn What Signing’s All About!
          </button>
        </div>
      </div>

      <div className="signposts-wrapper">
        <div className="container" ref={containerRef}>
          <div className="signposts">
            {signpostData.map(({ path, icon, alt, label, className }) => (
              <div className="signpost-wrapper" key={path}>
                <div
                  className={`signpost ${className}`}
                  onClick={(e) => handleNavigatePath(path, e)}
                >
                  <img src={icon} alt={alt} />
                  <p>{label}</p>
                </div>
                <div className="rod"></div>
              </div>
            ))}
          </div>
          <img
            ref={pokoRef}
            className="poko"
            src={pokoImg}
            alt="poko"
            style={pokoStyle}
            onAnimationEnd={handleAnimationEnd}
            onClick={() => setShowInstructions(true)}
          />
          {showIntroBubble && (
            <div className='intro-bubble'>
              Hey there! I’m Poko! <br />
              Pick a signpost to begin the fun! 🧭
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default HomePage;
